export const lowlockerTooltipImageLink =
  "https://storage.googleapis.com/harbor-public-assets/hal-admin-assets/tooltip_asfpoiroiklsdfgk2po4oi5676.png";
